<script setup lang="ts">
import type {
  EnterpriseInfo,
  GoodsBase,
  GoodsBrandMaster, GoodsContents,
  GoodsPriceHistory,
  LongTermInterestFreeInfo,
} from '~/types/goods/goods-detail'

const props = defineProps<{
  prGoodsBase: GoodsBase
  etEntrBase?: EnterpriseInfo
  prBrandMst: GoodsBrandMaster | null
  prGoodsPrceHist: GoodsPriceHistory[]
  longTermInterestFreeInfo: LongTermInterestFreeInfo | undefined
  goodsContentsDto: GoodsContents
  thumbnailGoodsImageUrl: string
}>()
const { prGoodsBase, prBrandMst, prGoodsPrceHist, longTermInterestFreeInfo, goodsContentsDto, thumbnailGoodsImageUrl } = toRefs(props)

// 상품 이미지 empty case, add dummy data
if (!goodsContentsDto.value.goodsImageContentList?.length) goodsContentsDto.value.goodsImageContentList = [{}]

const { isAdultGoods } = useGoodsBaseFlag(prGoodsBase.value)
</script>

<template>
  <!-- [S] 개요 영역 -->
  <div class="h-auto">
    <GoodsDetailMediaContents
      :pr-goods-base="prGoodsBase"
      :goods-contents-dto="goodsContentsDto"
    />
    <DisplayCornerAccount
      v-if="prGoodsBase.stgGoodsYn === 'Y'"
      adut-shop-cd="021"
    />
    <div class="p-4 bg-background-white">
      <GoodsDetailBasicInfo
        :pr-goods-base="prGoodsBase"
        :et-entr-base="etEntrBase"
        :pr-brand-mst="prBrandMst"
        :pr-goods-prce-hist="prGoodsPrceHist"
        :long-term-interest-free-info="longTermInterestFreeInfo"
        :thumbnail-goods-image-url="thumbnailGoodsImageUrl"
      />

      <GoodsDetailPayment
        :pr-goods-base="prGoodsBase"
        :pr-goods-prce-hist="prGoodsPrceHist"
        :pr-brand-mst="prBrandMst"
        :long-term-interest-free-info="longTermInterestFreeInfo"
        :thumbnail-goods-image-url="thumbnailGoodsImageUrl"
        :radio-mode="false"
      />
    </div>
    <!-- [S] 19세 인증 -->
    <template v-if="isAdultGoods">
      <div class="divider-thick bg-warm-gray-30" />
      <div class="px-4 py-4">
        <div class="flex items-start justify-between">
          <div class="shrink-0 w-[93px] text-16 font-medium">
            본인인증
          </div>
          <div class="grow text-16 text-on-view-02">
            <span class="font-medium text-on-view-01">19세 미만</span>의 청소년 접근이 제한된 상품으로 본인인증 후 구매할 수 있어요.
          </div>
        </div>
      </div>
    </template>
    <!-- [E] 19세 인증 -->
  </div>
  <!-- [E] 개요 영역 -->
</template>

<style scoped>

</style>
